var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon27(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50,20c11.2,0,20.9,5.3,28.9,15.7c4,5.2,6.7,10.6,8.2,14.1c-1.6,3.4-4.4,8.7-8.5,13.9C70.2,74.5,60.6,80,50,80 c-20.7,0-32.9-21.4-37.1-30.3C16.7,40.9,27.9,20,50,20 M50,8C12.9,8,0,50,0,50s15.1,42,50,42s50-42,50-42S87.1,8,50,8L50,8z M50,44 c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S46.7,44,50,44 M50,32c-9.9,0-18,8.1-18,18s8.1,18,18,18s18-8.1,18-18S59.9,32,50,32L50,32z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon27);
export default __webpack_public_path__ + "static/media/motion_icon-27.bbb5bddb.svg";
export { ForwardRef as ReactComponent };